import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=0878fc82&scoped=true&"
import script from "./BaseTooltip.vue?vue&type=script&lang=js&"
export * from "./BaseTooltip.vue?vue&type=script&lang=js&"
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=0878fc82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878fc82",
  null
  
)

export default component.exports